import styled from '@emotion/styled'
import React from 'react'
import BreakPoints from '../../styles/breakPoints'
import ColumnH1 from '../atoms/columnH1'
import Introduction004 from './Introduction004'
import Introduction005 from './Introduction005'
import Introduction006 from './Introduction006'
import Introduction007 from './Introduction007'
import Introduction008 from './Introduction008'
import Introduction009 from './Introduction009'
import Introduction010 from './Introduction010'
import Introduction011 from './Introduction011'
import Introduction012 from './Introduction012'

const Wrapper = styled.article`
  position: relative;
  margin-bottom: 30px;

  .p-txt-date {
    margin-top: -10px;
    color: #ababab;
  }

  section {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    font-size: 16px;
    color: #505050;
    line-height: 1.6em;

    h1 {
      color: #414141;
      font-size: 22px;
      line-height: 1.4em;
      background: #f5f5f5;
      border-radius: 3px;
      position: relative;
      width: 100%;
      padding: 5px 5px 5px 20px;
      margin-bottom: 30px;
      margin-top: 10px;

      &:before {
        content: '';
        position: absolute;
        width: 10px;
        background: #77d7c9;
        left: 0;
        top: 0;
        border-radius: 3px 0 0 3px;
        height: 100%;
      }
    }

    h2 {
      color: #414141;
      font-size: 22px;
      line-height: 1.4em;
      background: #ffffff;
      border-radius: 3px;
      position: relative;
      width: 100%;
      padding: 5px 5px 5px 20px;
      margin-top: 10px;
      margin-bottom: 30px;

      &:before {
        content: '';
        position: absolute;
        width: 10px;
        background: #d8d8d8;
        left: 0;
        top: 0;
        border-radius: 3px 0 0 3px;
        height: 100%;
      }
    }

    h3 {
      color: #414141;
      font-size: 16px;
      line-height: 1.4em;
      background: #ffffff;
      width: auto;
      padding: 10px 0 8px;
      margin-top: -10px;
      margin-bottom: 20px;
      border-top: solid 2px #e5e5e5;
      border-bottom: solid 2px #e5e5e5;
    }

    p {
      padding-bottom: 30px;
      line-height: 2;
      position: relative;

      span {
        background: linear-gradient(transparent 60%, #ff6 60%);
        font-weight: 600;
      }

      .p-list-link {
        position: absolute;
        top: 6px;
        right: 2px;

        &:before {
          display: block;
          content: '';
          position: absolute;
          width: 0;
          height: 0;
          top: 7px;
          left: -14px;
          border-left: 8px solid #3ec7b3;
          border-top: 4px solid transparent;
          border-bottom: 4px solid transparent;
        }
      }

      &.txt-color-red {
        color: #ff6969;
      }
    }

    .link-div {
      width: 100%;
      display: flex;
      justify-content: left;
      padding-bottom: 30px;

      > div {
        width: 50px;
      }

      .link-p {
        width: calc(100% - 50px);

        .p-list-link {
          position: absolute;
          top: -3px;
          left: 30px;

          &:before {
            display: block;
            content: '';
            position: absolute;
            width: 0;
            height: 0;
            top: 11px;
            left: -14px;
            border-left: 8px solid #3ec7b3;
            border-top: 4px solid transparent;
            border-bottom: 4px solid transparent;
          }
        }
      }
    }

    img {
      width: 100%;
      height: auto;
      padding-bottom: 30px;
    }
  }

  ${BreakPoints.large} {
  }
`
type Props = {
  /** 広告の番号 */
  no: number
}

/**
 * コラム記事詳細：記事本体
 * @constructor
 */
const ColumnDetailInner0100 = (props: Props): JSX.Element => (
  <Wrapper>
    <ColumnH1 label="副業・兼業における労務管理について。リスクと対策を紹介" />
    {/** TODO 川上申し送り事項：▼投稿日をここに表示 */}
    <p className="p-txt-date">2026.03.23</p>
    <section>
      {/** TODO 川上申し送り事項：▼記事投稿（？）で作成された内容がここに入る予定 */}
      <p>
        働き方改革の施行により、多様な働き方が尊重される時代となりました。厚生労働省が発信するモデル就業規則においても、事実上、副業を容認する規定内容に移行しています。そこで、今回は副業・兼業時の労務管理について解説します。
      </p>
      <img src="/images/column/details/c0100.jpg" alt="キンクラコラム画像100" />
      <div id="toc1">
        <h1>副業・兼業の現状や背景</h1>
      </div>
      <p>
        我が国の
        <span>
          高度経済成長期を支えた3種の神器（終身雇用、年功序列、企業別労組）が事実上の終焉を迎え
        </span>
        、新しい働き方を模索せざるを得ない社会経済情勢へと移行しました。特に
        <span>
          生活に直接的な影響がある「終身雇用と年功序列」については、労働者への影響が大きく
        </span>
        、1つの企業からの給与収入に頼る生活設計は
        <span>黄色信号が灯っていると考えられます</span>
        。また、万が一、人員整理などが行われた際にも、自社のみで通用するスキルを身に付けている状態では、他社への転職は容易では無いことから、在職中にある程度のスキルを身に付けておくべき機運が高まっています。そこで、いきなり転職となるとハードルが高くなることから、
        <span>
          在職中に副業・兼業を通じてスキルを身に付けながらも、一定の収入を得るとの発想が増えてきているのが現状
        </span>
        です。
      </p>

      <div id="toc2">
        <h1>複数の雇用主間での労働時間の管理方法と課題</h1>
      </div>
      <p>
        本業先も副業先もとに、雇用契約の場合には、当然、
        <span>労働時間の管理が必要不可欠となります</span>
        。当然、労働時間を管理するだけでなく、一定以上働いた場合には時間外労働の精査も必要です。時間外労働については、
        <span>
          労働基準法上、1日8時間を超えた場合と1週間で40時間を超えた場合の2つの軸で精査しなければなりません
        </span>
        。原則として副業・兼業の時間外労働の考え方については、
        <span>
          後から契約した事業場が割増賃金の支払い義務を負うことと解されます
        </span>
        。よって、リスクヘッジの意味を込めて、採用面接を行う場合には、現在、他に雇用契約関係にある事業場があるか否かは確認が必要です。
        <br />
        <br />
        また、それだけでなく、副業・兼業を認めるという事は、労働者の健康問題について、旧来よりも、よりきめ細やかに管理しなければならなくなります。定期健康診断の受診はもちろん、疲労の蓄積が見受けられた場合には、一定の休息や休暇の取得勧奨等は、時代背景上も必要不可欠な配慮となります。
      </p>

      {/** ここに9パターンの広告設定する */}
      {props.no === 0 && <Introduction004 />}
      {props.no === 1 && <Introduction005 />}
      {props.no === 2 && <Introduction006 />}
      {props.no === 3 && <Introduction007 />}
      {props.no === 4 && <Introduction008 />}
      {props.no === 5 && <Introduction009 />}
      {props.no === 6 && <Introduction010 />}
      {props.no === 7 && <Introduction011 />}
      {props.no === 8 && <Introduction012 />}

      <div id="toc3">
        <h1>企業側の必要な準備と注意点</h1>
      </div>
      <p>
        <span>原則として、副業・兼業は、事前承認制にすべきと考えます</span>
        。無制限に認めてしまうと、同業他社で副業・兼業することにより、
        <span>
          企業秘密が漏洩してしまったり、最悪の場合、人材そのものが流出してしまう可能性もゼロではありません
        </span>
        。また時間帯についても検討の余地があります。原則として、本業先の労務提供に
        <span>影響が出ない範囲内で認めるべき</span>
        であり、深夜労働が基本となる時間帯では、本業先の労務提供に影響が出てしまう事は容易に想像できます。
        <br />
        <br />
        副業収入が
        <span>一定額を超えた場合には確定申告が必要となります</span>
        。また、確定申告が必要とはならない範囲内の収入であったとしても、
        <span>
          市区町村への住民税の申告は必要であることから、ある程度の税務リテラシーを醸成する意味で企業からの一定の啓蒙活動も必要と言えます
        </span>
        。
        <br />
        <br />
        保険関係についても言及すると、例えば
        <span>
          本業先で週に20時間の雇用契約を締結している場合、原則として雇用保険の適用対象者であることが窺われます
        </span>
        。近年、法改正があったものの、64歳以下の雇用保険加入者については、1つの事業場のみでしか雇用保険被保険者にはなることができません。よって、本業先と副業先ともに週20時間以上の雇用契約であったとしても、64歳以下であれば、両事業場で雇用保険に加入するという事は理論上あり得ません。
        <br />
        <br />
        他方、労災保険については、両事業場で雇用関係にある場合、事故の発生状況によっては本業先ではなく、副業先の保険を使うことはあり得ます。そして、社会保険についても複数の事業場で加入するケースはあり得ます。例えば本業先でも加入しながら、副業で会社を立ち上げ、役員に就任し、かつ報酬を得ている場合には「2以上勤務」に該当し、双方の報酬を合算して社会保険料が決定されますので、注意点としては本業先の社会保険料が変更となることが考えられます。
      </p>

      <div id="toc4">
        <h1>労務トラブル事例と解決策</h1>
      </div>
      <p>
        副業・兼業を理由に時間外労働の必要性が高い時期についても
        <span>
          時間外労働が対応できなくなるという労働者が出てくる場合には、注意が必要
        </span>
        です。そのため、
        <span>許可制の場合、いつ副業・兼業を認めるのかは重要な論点</span>
        です。当然、副業・兼業先についても、雇用契約の場合、必要人員数でカウントしている労働者が来ないとなれば、問題となる事は明らかです。よって、本業先が副業・兼業を認めるにあたって、まずはどの程度の労働であれば、自社の労務提供に支障が出ないかを検討しておくことが重要です。
        <br />
        <br />
        次に、情報セキュリティー問題です。近年は、テレワークも普及し、テレワークを前提とした副業・兼業も多く存在します。
        <span>
          その場合、セキュリティーが脆弱な自宅PCにおいて、自社または副業・本業先の機密情報がウィルスにさらされてしまった場合には、企業の信用失意につながるリスクがあります
        </span>
        。よって、ウィルスソフトをインストールしてから業務を開始する事はもちろん、定期的なウィルスチェック、不審なメールは開封しないなどのリスクヘッジ策の継続的な徹底を呼びかけが必要です。
      </p>

      <div id="toc5">
        <h1>最後に</h1>
      </div>
      <p>
        副業・兼業は今後も広く浸透していくことが考えられます。よって企業としてもトラブルを未然に防ぐためのリスクヘッジ策に習熟し、労務管理を進めていく必要性が高まっています。
      </p>
    </section>
  </Wrapper>
)

export default ColumnDetailInner0100
